import { Button, makeStyles, Tooltip } from '@material-ui/core';
import React from 'react';
import { FileCopyOutlined } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
	Btn: {
		textTransform: 'none',
	},
}));
const SignedUrlCopyBtn = ({ permalink }) => {
	const classes = useStyles();
	const handleClick = () => {
		// copy permalink to clipboard
		navigator.clipboard.writeText(permalink);
	};
	return (
		<Tooltip title="Click to copy signed url" arrow={true} placement="top">
			<Button
				startIcon={<FileCopyOutlined />}
				color="primary"
				size="large"
				data-cy="signed-url-copy-btn"
				className={classes.Btn}
				onClick={handleClick}
			>
				Url
			</Button>
		</Tooltip>
	);
};

export default SignedUrlCopyBtn;
